import { $ as e, C as t, F as n, S as r, U as i, _ as a, f as o, g as s, h as c, i as l, m as u, ot as d, q as f, rt as p, t as m, v as h, w as g } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as _, t as v } from "./i18n-lite-BcmwMblk.js";
import { r as y, t as b } from "./normalize-props-DNjMoRjC.js";
import { n as x, r as S, t as C } from "./Cross.ce-B3B4wiAB.js";
import { t as w } from "./Stepper.ce-C5_sKJn0.js";
import { t as T } from "./stepper-B46XPcuc.js";
//#region src/webcomponents/quiz-stepper/locales/de-AT.json
var E = {}, D = {}, O = {}, k = {}, A = { "quiz-stepper": {
	feedback: {
		failed: "Pas tout à fait",
		success: "Bien joué"
	},
	nextStepButton: "Continuer",
	submitButton: "Valider"
} }, j = { "quiz-stepper": {
	submitButton: "Valider",
	nextStepButton: "Continuer",
	feedback: {
		success: "Bien joué",
		failed: "Pas tout à fait"
	}
} }, M = {}, N = {}, P = [
	"id",
	"aria-disabled",
	"checked"
], F = ["for"], I = {
	key: 0,
	class: "answer__subtitle"
}, L = { class: "answer__content" }, R = /*#__PURE__*/ m(/* @__PURE__ */ g({
	__name: "Answer.ce",
	props: {
		choice: { type: Object },
		showFeedback: { type: Boolean },
		isSelected: { type: Boolean },
		id: { type: String }
	},
	emits: ["select-answer"],
	setup(e, { emit: t }) {
		let r = t;
		function i() {
			r("select-answer", e.choice);
		}
		return (t, r) => (n(), h("div", { class: p(["answer", {
			"is-selected": e.isSelected,
			"is-disabled": e.showFeedback
		}]) }, [c("input", {
			id: e.id,
			type: "radio",
			name: "choice",
			"aria-disabled": e.showFeedback,
			checked: e.isSelected,
			class: "sr-only",
			onChange: i
		}, null, 40, P), c("label", { for: e.id }, [e.choice.title ? (n(), h("span", I, d(e.choice.title), 1)) : a("", !0), c("span", L, d(e.choice.content), 1)], 8, F)], 2));
	}
}), [["styles", [".answer{color:var(--neutral-900);text-align:left;background:#fff;border:1px solid #cdd1d9;border-radius:8px;flex-direction:column;flex:1;align-items:flex-start;gap:.25em;font-size:.875em;display:flex}.answer label{cursor:pointer;height:100%;padding:1em}.answer.is-selected{background:var(--neutral-800);color:#fff;border:1px solid #fff;border-radius:8px}.answer__subtitle{font-size:1em;font-weight:700;line-height:24px;display:block}.answer__content{text-wrap-mode:wrap;white-space-collapse:preserve}.answer .is-disabled{cursor:not-allowed}.answer:focus-within{outline:2px solid #000}"]]]), z = { class: "quiz-stepper-container__layout" }, B = ["aria-level"], V = { class: "card-wrapper" }, H = ["aria-disable"], U = /*#__PURE__*/ m(/* @__PURE__ */ g({
	__name: "QuizStepper.ce",
	props: {
		steps: { type: Array },
		titleLevel: {
			default: 2,
			type: Number
		}
	},
	setup(l, { expose: m }) {
		let g = e(0), v = e(), y = e(!1), b = i("form"), { t: T } = _(), E = u(() => l.steps?.[g.value]), D = u(() => !y.value), O = u(() => {
			let e = g.value === l.steps.length - 1;
			return !e || e && !y.value;
		}), k = u(() => D.value ? T("quiz-stepper.submitButton") : T("quiz-stepper.nextStepButton"));
		function A(e) {
			y.value || (v.value = e);
		}
		function j() {
			if (g.value + 1 > l.steps.length) {
				g.value = l.steps.length;
				return;
			}
			g.value++, y.value = !1, v.value = void 0, b.value?.focus();
		}
		function M() {
			v.value && (y.value = !0, g.value + 1 === l.steps.length && b.value?.focus());
		}
		function N() {
			if (D.value) {
				M();
				return;
			}
			j();
		}
		function P(e) {
			return e.content ? e.content === v.value?.content : e.title === v.value?.title;
		}
		function F() {
			g.value = 0, v.value = void 0, y.value = !1;
		}
		return m({ reset: F }), (e, i) => (n(), h("form", {
			ref_key: "form",
			ref: b,
			class: "quiz-stepper-container",
			tabindex: "-1",
			onSubmit: o(N, ["prevent"])
		}, [c("div", z, [
			t(w, {
				step: g.value,
				"steps-count": l.steps.length
			}, null, 8, ["step", "steps-count"]),
			c("fieldset", null, [c("legend", null, [c("div", {
				role: "heading",
				"aria-level": l.titleLevel,
				class: "question"
			}, d(E.value.question), 9, B)]), c("div", V, [t(R, {
				id: "choice1",
				choice: E.value.choice1,
				"show-feedback": y.value,
				"is-selected": P(E.value.choice1),
				onSelectAnswer: i[0] ||= (e) => A(E.value.choice1)
			}, null, 8, [
				"choice",
				"show-feedback",
				"is-selected"
			]), t(R, {
				id: "choice2",
				choice: E.value.choice2,
				"show-feedback": y.value,
				"is-selected": P(E.value.choice2),
				onSelectAnswer: i[1] ||= (e) => A(E.value.choice2)
			}, null, 8, [
				"choice",
				"show-feedback",
				"is-selected"
			])])]),
			t(S, { "display-feedback": y.value }, {
				icon: f(() => [v.value?.isGoodAnswer ? (n(), s(x, { key: 0 })) : (n(), s(C, { key: 1 }))]),
				title: f(() => [r(d(v.value?.isGoodAnswer ? e.$t("quiz-stepper.feedback.success") : e.$t("quiz-stepper.feedback.failed")), 1)]),
				content: f(() => [r(d(v.value?.isGoodAnswer ? E.value.feedback.success : E.value.feedback.failed), 1)]),
				_: 1
			}, 8, ["display-feedback"]),
			O.value ? (n(), h("button", {
				key: 0,
				type: "submit",
				class: p(["submit-button", { "is-disabled": !v.value }]),
				"aria-disable": !v.value
			}, d(k.value), 11, H)) : a("", !0)
		])], 544));
	}
}), [["styles", ["*{--neutral-800:#253858;--neutral-900:#122647;font-family:Roboto,sans-serif}.sr-only{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.quiz-stepper-container{color:var(--neutral-800);flex-direction:column;align-items:center;display:flex}.quiz-stepper-container button{cursor:pointer}.quiz-stepper-container fieldset{border:none}.quiz-stepper-container legend{margin-bottom:1.5em}.quiz-stepper-container__layout{flex-direction:column;align-items:center;gap:1.5em;width:80%;padding:1.5em 1em;display:flex}.quiz-stepper-container .question{color:var(--neutral-900);text-align:center;font-family:Nunito;font-size:1.25em;font-style:normal;font-weight:700;line-height:28px}.quiz-stepper-container .card-wrapper{background:#f4f5f7;border-radius:16px;justify-content:center;gap:1.5em;width:calc(100% - 3em);padding:1.5em;display:flex}.quiz-stepper-container .submit-button{color:#fff;background:#253858;border:none;border-radius:8px;justify-content:center;align-items:center;gap:.5em;padding:.5em 1.5em;font-weight:700;display:flex}.quiz-stepper-container .submit-button.is-disabled{cursor:not-allowed;background:#cdd1d9}@media screen and (width<=630px){.quiz-stepper-container__layout{width:calc(100% - 1em);padding:1em .5em}.quiz-stepper-container .card-wrapper{flex-direction:column;width:calc(100% - 2em);padding:1em}}"]]]);
v.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": E,
	"./locales/en.json": D,
	"./locales/es-419.json": O,
	"./locales/es.json": k,
	"./locales/fr-BE.json": A,
	"./locales/fr.json": j,
	"./locales/it.json": M,
	"./locales/nl.json": N
})), T();
var W = l(U, { configureApp(e) {
	v.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(v);
} });
W.prototype.normalizeProps = (e) => {
	let { steps: t, titleLevel: n } = e;
	return t = t.map((e) => {
		let { choice1: t, choice2: n } = e;
		return t = {
			...e.choice1,
			title: y(t.title),
			content: y(t.content)
		}, n = {
			...e.choice2,
			title: y(n.title),
			content: y(n.content)
		}, {
			...e,
			choice1: t,
			choice2: n
		};
	}), {
		steps: t,
		titleLevel: b(n)
	};
}, window.customElements.define("quiz-stepper", W);
//#endregion
